// src/components/InstallBanner.tsx
import React, {useState, useEffect} from 'react';
import {X, Download, Smartphone} from 'lucide-react';

const InstallBanner: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [showBanner, setShowBanner] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // تحقق إذا التطبيق مثبت
        if (window.matchMedia('(display-mode: standalone)').matches) {
            setIsInstalled(true);
            return;
        }

        // استمع لحدث التثبيت
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowBanner(true);
        });

        window.addEventListener('appinstalled', () => {
            setIsInstalled(true);
            setShowBanner(false);
        });
    }, []);

    const handleInstall = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const {outcome} = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            // console.log('User accepted install');
            setShowBanner(false);
        }
        setDeferredPrompt(null);
    };

    if (isInstalled || !showBanner) return null;

    return (
        <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-600 to-blue-700 text-white z-50 shadow-lg">
            <div className="container mx-auto px-4 py-3">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3 flex-1">
                        <Smartphone className="w-5 h-5 flex-shrink-0" />
                        <p className="text-sm md:text-base">
                            <span className="font-bold">SMS Reselling</span> - حمّل التطبيق واستمتع بتجربة أسرع!
                        </p>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <button
                            onClick={handleInstall}
                            className="bg-white text-blue-600 hover:bg-blue-50 px-4 py-1.5 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors"
                        >
                            <Download className="w-4 h-4" />
                            تثبيت
                        </button>
                        <button
                            onClick={() => setShowBanner(false)}
                            className="text-white/80 hover:text-white p-1.5"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstallBanner;